import createIcon from '@/lib/create-icon'

const DartsIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M27.381 18.7859H33.7111M27.381 18.7859V12.4558M27.381 18.7859L22.9047 23.2629M27.381 18.7859L27.3805 13.4944M27.381 18.7859L32.6722 18.7858M33.7111 18.7859L41.3072 11.1898M33.7111 18.7859L38.3292 14.1672M33.7111 18.7859L32.6722 18.7858M41.3072 11.1898H34.9771L34.8368 5M41.3072 11.1898L38.3292 14.1672M34.8368 5L27.381 12.4558M34.8368 5L31.9989 7.83725M27.381 12.4558L31.9989 7.83725M27.381 12.4558L27.3805 13.4944M31.9989 7.83725C29.3335 6.26233 26.2244 5.35859 22.9042 5.35859C13.016 5.35859 5 13.3746 5 23.2627C5 33.1509 13.016 41.1669 22.9042 41.1669C32.7924 41.1669 40.8083 33.1509 40.8083 23.2627C40.8083 19.9422 39.9044 16.8328 38.3292 14.1672M27.3805 13.4944C26.0178 12.869 24.5017 12.5203 22.9042 12.5203C16.9712 12.5203 12.1617 17.3298 12.1617 23.2627C12.1617 29.1957 16.9712 34.0052 22.9042 34.0052C28.8371 34.0052 33.6467 29.1957 33.6467 23.2627C33.6467 21.6649 33.2978 20.1486 32.6722 18.7858'
      stroke='url(#paint0_linear_5305_2484)'
      strokeWidth='2.68562'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M27.381 18.7859H33.7111M27.381 18.7859V12.4558M27.381 18.7859L22.9047 23.2629M27.381 18.7859L27.3805 13.4944M27.381 18.7859L32.6722 18.7858M33.7111 18.7859L41.3072 11.1898M33.7111 18.7859L38.3292 14.1672M33.7111 18.7859L32.6722 18.7858M41.3072 11.1898H34.9771L34.8368 5M41.3072 11.1898L38.3292 14.1672M34.8368 5L27.381 12.4558M34.8368 5L31.9989 7.83725M27.381 12.4558L31.9989 7.83725M27.381 12.4558L27.3805 13.4944M31.9989 7.83725C29.3335 6.26233 26.2244 5.35859 22.9042 5.35859C13.016 5.35859 5 13.3746 5 23.2627C5 33.1509 13.016 41.1669 22.9042 41.1669C32.7924 41.1669 40.8083 33.1509 40.8083 23.2627C40.8083 19.9422 39.9044 16.8328 38.3292 14.1672M27.3805 13.4944C26.0178 12.869 24.5017 12.5203 22.9042 12.5203C16.9712 12.5203 12.1617 17.3298 12.1617 23.2627C12.1617 29.1957 16.9712 34.0052 22.9042 34.0052C28.8371 34.0052 33.6467 29.1957 33.6467 23.2627C33.6467 21.6649 33.2978 20.1486 32.6722 18.7858'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.68562'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M27.381 18.7859H33.7111M27.381 18.7859V12.4558M27.381 18.7859L22.9047 23.2629M27.381 18.7859L27.3805 13.4944M27.381 18.7859L32.6722 18.7858M33.7111 18.7859L41.3072 11.1898M33.7111 18.7859L38.3292 14.1672M33.7111 18.7859L32.6722 18.7858M41.3072 11.1898H34.9771L34.8368 5M41.3072 11.1898L38.3292 14.1672M34.8368 5L27.381 12.4558M34.8368 5L31.9989 7.83725M27.381 12.4558L31.9989 7.83725M27.381 12.4558L27.3805 13.4944M31.9989 7.83725C29.3335 6.26233 26.2244 5.35859 22.9042 5.35859C13.016 5.35859 5 13.3746 5 23.2627C5 33.1509 13.016 41.1669 22.9042 41.1669C32.7924 41.1669 40.8083 33.1509 40.8083 23.2627C40.8083 19.9422 39.9044 16.8328 38.3292 14.1672M27.3805 13.4944C26.0178 12.869 24.5017 12.5203 22.9042 12.5203C16.9712 12.5203 12.1617 17.3298 12.1617 23.2627C12.1617 29.1957 16.9712 34.0052 22.9042 34.0052C28.8371 34.0052 33.6467 29.1957 33.6467 23.2627C33.6467 21.6649 33.2978 20.1486 32.6722 18.7858'
      stroke='url(#paint1_radial_5305_2484)'
      strokeOpacity='0.6'
      strokeWidth='2.68562'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5305_2484'
        x1='5'
        y1='5'
        x2='46.4'
        y2='33.8615'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5305_2484'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.1536 41.1669) scale(18.1536 18.4175)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'DartsIcon'
)

export default DartsIcon
